// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"loginPage_loginPage__2v5Gy","rightStyle":"loginPage_rightStyle__HaS_p"};